import React from 'react';
import big_coin from "../../../_asset/source/big_coin.png";
import small_coin from "../../../_asset/source/small_coin.png";

export function FloatLayout({girl}: {girl: string}) {
    return (
        <div className={'float-layout'}>
            <div className={'float-images'}>
                <img src={girl} className={`casino-girl`} alt="girl" />

                {/* <div className={'coin-1'}>
                    <img src={big_coin}  />
                </div>
                <div className={'coin-2'}>
                    <img src={small_coin} />
                </div> */}
            </div>
        </div>
    );
}
FloatLayout.defaultProps = {
    girl: ""
}